import { signal } from '@preact/signals';

export type Route =
  | { name: 'today' }
  | { name: 'stock'; filter?: 'low' | 'dead' }
  | { name: 'sales' }
  | { name: 'purchases' }
  | { name: 'parties' }
  | { name: 'party'; id: string }
  | { name: 'payments' }
  | { name: 'returns' }
  | { name: 'money' }
  | { name: 'bank' }
  | { name: 'reports' }
  | { name: 'more' }
  | { name: 'settings' }
  | { name: 'memo'; id: string }
  | { name: 'books' }
  | { name: 'ledger'; id: string };

export type RouteName = Route['name'];

function parse(hash: string): Route {
  const parts = hash.replace(/^#\/?/, '').split('/').filter(Boolean);
  const [head, arg] = parts;
  switch (head) {
    case undefined:
    case '':
    case 'today':
      return { name: 'today' };
    case 'stock':
      return arg === 'low' || arg === 'dead' ? { name: 'stock', filter: arg } : { name: 'stock' };
    case 'party':
      return arg ? { name: 'party', id: decodeURIComponent(arg) } : { name: 'parties' };
    case 'memo':
      return arg ? { name: 'memo', id: decodeURIComponent(arg) } : { name: 'sales' };
    case 'ledger':
      return arg ? { name: 'ledger', id: decodeURIComponent(arg) } : { name: 'bank' };
    case 'sales':
    case 'purchases':
    case 'parties':
    case 'payments':
    case 'returns':
    case 'money':
    case 'bank':
    case 'reports':
    case 'more':
    case 'settings':
    case 'books':
      return { name: head };
    default:
      return { name: 'today' };
  }
}

export const route = signal<Route>(parse(typeof location !== 'undefined' ? location.hash : ''));

if (typeof window !== 'undefined') {
  window.addEventListener('hashchange', () => {
    route.value = parse(location.hash);
    window.scrollTo(0, 0);
  });
}

export function href(name: RouteName, arg?: string): string {
  return arg ? `#/${name}/${encodeURIComponent(arg)}` : `#/${name}`;
}

export function go(name: RouteName, arg?: string): void {
  const h = href(name, arg);
  if (location.hash === h) {
    route.value = parse(h);
    window.scrollTo(0, 0);
  } else location.hash = h;
}
